<div class="page-container">
  <div class="page-header">
    <div class="header-left">
      <button mat-icon-button routerLink="/wartung" matTooltip="Zurück zum Dashboard">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <span class="eyebrow">Kundenauswahl</span>
        <h1>Kunden</h1>
        <p class="subtitle">{{customers.length}} Kunden · {{totalEquipment}} Anlagen · {{totalActive}} offene Aufträge</p>
      </div>
    </div>
    <button mat-raised-button color="primary" *ngIf="canEdit" (click)="openCustomerForm()">
      <mat-icon>person_add</mat-icon>
      Neuer Kunde
    </button>
  </div>

  <section class="selection-panel">
    <div class="search-bar">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text"
             placeholder="Kunde, Kontakt, Ort oder Anlage suchen"
             [(ngModel)]="searchTerm"
             (ngModelChange)="applyFilter()"
             (keydown.enter)="openFirstResult()">
      <button mat-icon-button *ngIf="searchTerm" (click)="clearSearch()" class="clear-btn" matTooltip="Suche löschen">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="selection-tools">
      <div class="filter-row" aria-label="Kunden filtern">
        <button type="button"
                class="filter-chip"
                *ngFor="let option of customerFilters"
                [class.active]="customerFilter === option.key"
                (click)="setCustomerFilter(option.key)">
          <mat-icon>{{option.icon}}</mat-icon>
          <span>{{option.label}}</span>
          <strong>{{getFilterCount(option.key)}}</strong>
        </button>
      </div>

      <mat-form-field appearance="outline" class="sort-field">
        <mat-label>Sortierung</mat-label>
        <mat-select [ngModel]="sortMode" (ngModelChange)="setSortMode($event)">
          <mat-option value="attention">Priorität</mat-option>
          <mat-option value="name">Name A-Z</mat-option>
          <mat-option value="nextDate">Nächster Termin</mat-option>
          <mat-option value="active">Offene Aufträge</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-stroked-button class="reset-filters-btn" *ngIf="hasActiveFilters" (click)="resetFilters()">
        <mat-icon>filter_alt_off</mat-icon>
        Zurücksetzen
      </button>
    </div>
  </section>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <div *ngIf="!loading && filteredCustomers.length === 0" class="empty-state">
    <mat-icon>{{customers.length === 0 ? 'groups' : 'search_off'}}</mat-icon>
    <h3>{{customers.length === 0 ? 'Noch keine Kunden' : 'Keine passenden Kunden'}}</h3>
    <p>{{customers.length === 0 ? 'Lege den ersten Kunden an und füge danach Anlagen und Aufträge hinzu.' : 'Ändere Suche, Filter oder Sortierung.'}}</p>
    <button *ngIf="customers.length === 0 && canEdit" mat-raised-button color="primary" (click)="openCustomerForm()">
      <mat-icon>add</mat-icon>
      Ersten Kunden anlegen
    </button>
  </div>

  <div *ngIf="!loading && filteredCustomers.length > 0" class="result-header">
    <span>{{filteredCustomers.length}} angezeigt</span>
    <span *ngIf="totalOverdue > 0" class="overdue-note">
      <mat-icon>warning</mat-icon>
      {{totalOverdue}} überfällige Aufträge
    </span>
  </div>

  <div *ngIf="!loading && filteredCustomers.length > 0" class="customer-grid">
    <article class="customer-card"
             *ngFor="let c of filteredCustomers; trackBy: trackByCustomerId"
             (click)="openCustomer(c)"
             [class.status-warn]="getCustomerStatus(c) === 'warn'"
             [class.status-danger]="getCustomerStatus(c) === 'danger'">

      <div class="card-header">
        <div class="customer-avatar" *ngIf="!c.logoPath" [class.warn]="getCustomerStatus(c) === 'warn'" [class.danger]="getCustomerStatus(c) === 'danger'">
          {{c.name.charAt(0).toUpperCase()}}
        </div>
        <div class="customer-logo" *ngIf="c.logoPath">
          <img [src]="getLogoUrl(c.logoPath)" alt="Logo">
        </div>

        <div class="customer-name-block">
          <div class="name-row">
            <h3>{{c.name}}</h3>
            <span class="stammkunde-badge" *ngIf="c.type === 'Stammkunde'" title="Stammkunde mit eigener Personen-Einsatzplanung">
              <mat-icon class="inline-icon">badge</mat-icon> Stammkunde
            </span>
            <span class="status-pill" [class.warn]="getCustomerStatus(c) === 'warn'" [class.danger]="getCustomerStatus(c) === 'danger'">
              {{getCustomerStatusLabel(c)}}
            </span>
          </div>
          <span class="address" *ngIf="c.address">
            <mat-icon class="inline-icon">location_on</mat-icon>
            {{c.address}}
          </span>
        </div>

        <div class="card-actions" *ngIf="canEdit">
          <button mat-icon-button (click)="editCustomer(c, $event)" matTooltip="Bearbeiten">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteCustomer(c, $event)" matTooltip="Löschen">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

      <div class="equipment-preview">
        <mat-icon>electrical_services</mat-icon>
        <span>{{getEquipmentPreview(c)}}</span>
      </div>

      <div class="card-stats">
        <div class="card-stat">
          <strong>{{getEquipmentCount(c)}}</strong>
          <span>Anlagen</span>
        </div>
        <div class="card-stat">
          <strong>{{getActiveCount(c)}}</strong>
          <span>Offen</span>
        </div>
        <div class="card-stat" [class.overdue]="getOverdueCount(c) > 0">
          <strong>{{getNextMaintenanceLabel(c)}}</strong>
          <span>Nächster Termin</span>
        </div>
      </div>

      <div class="card-footer">
        <div class="contact-info">
          <mat-icon class="inline-icon">person</mat-icon>
          {{getPrimaryContact(c)}}
        </div>
        <div class="card-footer-actions">
          <button mat-icon-button *ngIf="canEdit" matTooltip="Wartung planen"
                  (click)="openCustomerWithAction(c,'plan',$event)">
            <mat-icon>event_repeat</mat-icon>
          </button>
          <button mat-icon-button *ngIf="canEdit" matTooltip="Einsatz erfassen"
                  (click)="openCustomerWithAction(c,'service',$event)">
            <mat-icon>build</mat-icon>
          </button>
          <button mat-stroked-button class="open-button" (click)="openCustomer(c); $event.stopPropagation()">
            Öffnen
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </article>
  </div>
</div>
